import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaSearchPanel = Loadable({
  loader: () => import("./SearchPanel"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaSearchPanel;



// WEBPACK FOOTER //
// ./ecology9/wea-search-panel/index.js